import React, { useState } from "react";
import { BaseButton } from "src/components/ui/baseButton";
import { FileDownloadIcon } from "../icons";
import { Text } from "src/components/ui/Text";
import DialogDownloadCSV from "../dialogs/DialogDownloadCSV";

const BtnDownloadCSV = () => {
  //   const [isLoadingDownloadCSV, setIsLoadingDownloadCSV] = useState(false);
  const [openDialogDownloadCSV, setOpenDialogDownloadCSV] = useState(false);

  return (
    <div>
      <BaseButton
        variant="primary"
        size="normal"
        onClick={() => setOpenDialogDownloadCSV(true)}
      >
        <div className="flex gap-1 items-center">
          <FileDownloadIcon />
          <Text variant="semi-12">Download CSV report</Text>
        </div>
      </BaseButton>

      {openDialogDownloadCSV && (
        <div>
          <DialogDownloadCSV onClose={() => setOpenDialogDownloadCSV(false)} />
        </div>
      )}
    </div>
  );
};

export default BtnDownloadCSV;
